// extracted by mini-css-extract-plugin
export default {"icon":"PostLikeHeart-module-icon-zSdEL","likesPost":"PostLikeHeart-module-likesPost-GRVIG"};